var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 26.875H28.8938M26.25 21.25H30.75C32.4973 21.25 33.3709 21.25 34.0601 21.5354C34.9789 21.916 35.709 22.6461 36.0896 23.5649C36.375 24.2541 36.375 25.1277 36.375 26.875C36.375 28.6223 36.375 29.4959 36.0896 30.1851C35.709 31.1039 34.9789 31.834 34.0601 32.2146C33.3709 32.5 32.4973 32.5 30.75 32.5H8.25C6.50273 32.5 5.62909 32.5 4.93993 32.2146C4.02109 31.834 3.29106 31.1039 2.91045 30.1851C2.625 29.4959 2.625 28.6223 2.625 26.875C2.625 25.1277 2.625 24.2541 2.91045 23.5649C3.29106 22.6461 4.02109 21.916 4.93993 21.5354C5.62909 21.25 6.50273 21.25 8.25 21.25H12.75M19.5 23.125V2.5M19.5 2.5L25.125 8.125M19.5 2.5L13.875 8.125",
    stroke: "#399E79",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconActive);
export default __webpack_public_path__ + "static/media/UploadIconActive.e9e46a713053403026b58d9d1c3ead95.svg";
export { ForwardRef as ReactComponent };